(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ogdf", [], factory);
	else if(typeof exports === 'object')
		exports["ogdf"] = factory();
	else
		root["ogdf"] = factory();
})(self, function() {
return 